import { IconModuleObjectives } from 'featherico';
import api from '../../../../../../../api';

const STATUS = {
    OK: 'OK',
    NOT_FOUND: 'NOT_FOUND',
    PRIVATE: 'NOT_ALLOWED_TO_SEE',
};

export const type = 'objective';
export const reFragment = 'app/objectives/';
export const checkId = id => /[^\\s]+\/[^\\s]+/.test(id);

export const resolve = {
    previewWithStatus: ({ id }) => {
        const objectiveId = id.match(/.+\/(.*)$/)[1];
        return api.contentItemPreview.getObjectivePreview({ id: objectiveId });
    },
};

export const render = props => {
    const { preview, status } = props.previewWithStatus;
    if (status === STATUS.OK) {
        return preview.title;
    }
    if (status === STATUS.NOT_FOUND) {
        return 'Non-existant objective';
    }
    if (status === STATUS.PRIVATE) {
        return 'Private objective';
    }
};

export const isErrorState = props => {
    return props.previewWithStatus && props.previewWithStatus.status !== STATUS.OK;
};

export const getIcon = () => {
    return <IconModuleObjectives />;
};
